$(document).ready(function(){
  console.log("ENGINE STARTED");
  
  if ($(".product-single__title").html() == "Shopify Starter" || $(".product-single__title").html() == "Shopify Premium"){
  	
    console.log($(".product-single__title").html());
    
    $(".add-to-cart").prop('disabled', true);
    $(".add-to-cart").css("cursor","pointer");    
    $(".add-to-cart").css("background-color","#1c1d1d");
    $(".add-to-cart-text").css("color","#ffffff");    
    $(".product-single__add-to-cart").mouseover(function(){$(this).css("opacity","0.8");});
    $(".product-single__add-to-cart").mouseout(function(){$(this).css("opacity","1");});
      													
    
    
    $(".product-single__add-to-cart").click(function(){
      									window.location = "https://ecommerce-concierge.net/pages/get-a-free-quote"
    });
  }
  else if($(".product-single__title").html() == "Shopify Customization"){
    
    console.log($(".product-single__title").html());
    
    $(':input[type="submit"]').prop('disabled', true);
    $(':input[type="submit"]').css("cursor","pointer");
    $(".add-to-cart").css("background-color","#1c1d1d");
    $(".add-to-cart-text").css("color","#ffffff");    
    $(".product-single__add-to-cart").mouseover(function(){$(this).css("opacity","0.8");});
    $(".product-single__add-to-cart").mouseout(function(){$(this).css("opacity","1");});
    
    $(".product-single__add-to-cart").click(function(){
      									window.location = "https://ecommerce-concierge.net/pages/how-can-we-help"
    });
    
  }

sections.register('quotes', theme.Quotes);

})

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();